module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav-bar', {
    attrs: {
      "title": "Refresh & Infinite"
    }
  }), _vm._v(" "), _c('scroller', {
    ref: "my_scroller",
    staticStyle: {
      "top": "44px"
    },
    attrs: {
      "on-refresh": _vm.refresh,
      "on-infinite": _vm.infinite
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      staticClass: "row",
      class: {
        'grey-bg': index % 2 == 0
      },
      on: {
        "click": function($event) {
          _vm.onItemClick(index, item)
        }
      }
    }, [_vm._v("\n      " + _vm._s(item) + "\n    ")])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1217a566"}!./~/vue-loader/lib/selector.js?type=template&index=0!./demo/components/RefreshAndInfinite.vue
// module id = 40
// module chunks = 0